import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from './Card';
import { addToArray } from '../../utils/immutable';
import './styles.styl';

class ModalCards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: null
    };
  }

  handleClick = card => {
    const { data, input, onInput, onCompletion } = this.props;
    const { open } = this.state;

    if (!input || !input.includes(card)) {
      const payload = addToArray(input, card);
      onInput(payload);
      if (payload.length === data.length) {
        onCompletion();
      }
    }

    this.setState({
      open: open === card ? null : card
    });
  };

  render() {
    const { data, input } = this.props;
    const { open } = this.state;
    return (
      <div className="comet-cards">
        {data.map((card, i) => (
          <Card
            key={i}
            data={card}
            onClick={this.handleClick}
            open={open === card.modal.title}
            opened={input && input.includes(card.modal.title)}
          />
        ))}
        <div className="comet-card comet-card--invisible" />
        <div className="comet-card comet-card--invisible" />
        <div className="comet-card comet-card--invisible" />
      </div>
    );
  }
}

ModalCards.defaultProps = {};

ModalCards.propTypes = {
  data: PropTypes.array.isRequired,
  input: PropTypes.array,
  onInput: PropTypes.func.isRequired,
  onCompletion: PropTypes.func.isRequired
};

export default ModalCards;



// WEBPACK FOOTER //
// ../core/src/components/ModalCards/ModalCards.js